import * as React from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgOrderStatusPacked = function SvgOrderStatusPacked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 3.75C3 3.33579 3.33579 3 3.75 3H4.75C6.26878 3 7.5 4.23122 7.5 5.75V13.575C8.96935 13.8733 10.1267 15.0306 10.425 16.5H20.25C20.6642 16.5 21 16.8358 21 17.25C21 17.6642 20.6642 18 20.25 18H10.425C10.0775 19.7117 8.56421 21 6.75 21C4.67894 21 3 19.3211 3 17.25C3 15.4357 4.28833 13.9225 6 13.575V5.75C6 5.05964 5.44036 4.5 4.75 4.5H3.75C3.33579 4.5 3 4.16421 3 3.75ZM10 6.75C10 5.23122 11.2312 4 12.75 4H18.25C19.7688 4 21 5.23122 21 6.75V11.25C21 12.7688 19.7688 14 18.25 14H12.75C11.2312 14 10 12.7688 10 11.25V6.75ZM12.75 5.5C12.0596 5.5 11.5 6.05964 11.5 6.75V11.25C11.5 11.9404 12.0596 12.5 12.75 12.5H18.25C18.9404 12.5 19.5 11.9404 19.5 11.25V6.75C19.5 6.05964 18.9404 5.5 18.25 5.5H16.25V8.25C16.25 8.66421 15.9142 9 15.5 9C15.0858 9 14.75 8.66421 14.75 8.25V5.5H12.75ZM6.75 15C5.50736 15 4.5 16.0073 4.5 17.25C4.5 18.4927 5.50736 19.5 6.75 19.5C7.99264 19.5 9 18.4927 9 17.25C9 16.0073 7.99264 15 6.75 15Z"
  })));
};

export { SvgOrderStatusPacked as ReactComponent };
//# sourceMappingURL=order-status-packed.svg.js.map
